module.exports = __webpack_public_path__ + "static/logo-361f72fa71125edd53bf04f6a859c91e.jpeg";